document.addEventListener('DOMContentLoaded', function() {
  // Sezione "Come funziona"
  const section1 = document.querySelector('#shopify-section-template--28097118175615__section_KtceeU');
  if (section1) {
    const revealElements1 = section1.querySelectorAll('p');
    animateElements(revealElements1);
  }
  
// Sezione "La soluzione è WellDome"
const section2 = document.querySelector('#shopify-section-template--28097118175615__section_7drdMY');
if (section2) {
  const revealElements2 = section2.querySelectorAll('p, h2, h3, li');
  animateElements(revealElements2);
}

  
  function animateElements(elements) {
    const revealOnScroll = () => {
      elements.forEach(element => {
        const elementTop = element.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        
        if (elementTop < windowHeight * 0.85) {
          element.classList.add('revealed');
        }
      });
    };
    
    window.addEventListener('scroll', revealOnScroll);
    revealOnScroll();
  }
});

